import { useHistory } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { ButtonLink } from '@taxfix/scouts-ui'

import { PATH_LOGIN } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return <ButtonLink onClick={() => history.push(PATH_LOGIN)}>Already have an account? Log in here</ButtonLink>
}
export const Signup = () => {
    return (
        <Auth.LockscreenLayout title="Let's get started" footer={<Footer />}>
            <Auth.SignupForm />
        </Auth.LockscreenLayout>
    )
}
